import { render, staticRenderFns } from "./SupplyChain.vue?vue&type=template&id=77817c81&scoped=true"
import script from "./SupplyChain.vue?vue&type=script&lang=js"
export * from "./SupplyChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77817c81",
  null
  
)

export default component.exports